export default __webpack_public_path__ + "static/media/Group King's Feast.74bd625d.jpg";